import { useEffect } from "react";
import Popup from "reactjs-popup";
import "./TermsPopUp.scss";

export default function TermsPopUp({
  children,
  openModal,
  setOpenModal,
  fullWidth = 0,
}: any) {
  // This function is called when the "OK" button is clicked
  const closeModal = () => {
    setOpenModal(false);
    localStorage.setItem("termsAccepted", "true"); // Set a flag in localStorage when the user accepts the terms
  };

  // Effect to check if terms have been accepted previously
  useEffect(() => {
    const termsAccepted = localStorage.getItem("termsAccepted"); // Get the flag from localStorage
    if (termsAccepted) {
      setOpenModal(false); // If terms have been accepted before, don't show the popup
    }
  }, [setOpenModal]);

  return (
    <Popup
      open={openModal}
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={closeModal}
    >
      <div className={`modal ${fullWidth === 1 ? "full-width" : ""}`}>
        {children}
        <button className="ok-button" onClick={closeModal}>
          Accept
        </button>
      </div>
    </Popup>
  );
}
